export default __webpack_public_path__ + "static/nextgen-a42c15d099c44c9db1e5e270f5591d1e.png";